import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';

const cle = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
const stripePromise = cle ? loadStripe(cle) : null;

/**
 * Le paiement Stripe embarqué du portail (11/10/2026) : formules et dossiers
 * supplémentaires se paient ici, pour toute la suite (même composant que les
 * produits avaient chacun).
 */
export function PaiementStripe({ clientSecret }: { clientSecret: string }) {
  if (!stripePromise) {
    return (
      <p className="dos-erreur" role="alert">
        VITE_STRIPE_PUBLIC_KEY manquante : le paiement ne peut pas s’afficher.
      </p>
    );
  }
  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
